import ObjectCache from './CacheService';
import LogicBaseBlockApi from '../server/LogicBaseBlockApi';
import UserAccount from '../UserAccount';
import LogicBaseBlock from '../../models/logicbaseblock';

class LogicBaseBlockCache extends ObjectCache {
  api = LogicBaseBlockApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseBlock(results._id, results.br, results.be);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseBlockCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
